<template>
	<div class="dp" :style="{ backgroundColor: data.basics.backGroundColor || 'rgb(0,0,0)' }">
		<div v-if="difference2 == '过期'" class="dqtx">
			<div>
				<p v-if="data.basics.expireFlag">您的软件已经过期{{ timeDifference ? timeDifference : "超过一周啦" }}</p>
				<p v-if="!data.basics.status && !data.basics.expireFlag">您的软件已被禁用</p>
				<p>请及时联系您的业务员或拨打电话进行续费</p>
				<p>
					服务热线：
					<a href="13267110818">13267110818</a>
				</p>
			</div>
		</div>
		<!-- 水印 -->
		<WaterMarks v-if="data.basics.waterMarkFlag" />
		<FloatingWindow v-if="timeDifference" width="300px" height="85px">
			<p>中威软件温馨提示：</p>
			<p style="text-align: left">
				您的软件将在
				<a style="color: red">{{ timeDifference }}</a>
				后到期，请及时续费,以免影响您的正常使用！
			</p>
		</FloatingWindow>
		<notPage v-if="data.notPages" />
		<!-- :style="{ backgroundColor: adjustGrayscaleRgb(data.basics.backGroundColor || 'rgb(0,0,0)') }"  -->
		<div style="background: #82545e; position: fixed; width: 100vw; text-align: center; height: 100vh; padding: 10vh 5vh; padding-top: 15vh">
			<div style="background: #fff; position: relative; color: #333; height: 70vh">
				<div style="display: flex; align-items: center">
					<div style="width: 50%; position: relative; top: 5rem">
						<div style="overflow: hidden; display: flex; justify-content: center; align-items: baseline">
							<div
								style="height: 20vh"
								:style="{
									transform: `translateY(${offset}px)`,
									transition: transition
								}"
							>
								<!-- 当前 -->
								<span style="height: 20vh; font-weight: bold; display: block; font-size: 15vh; color: #82545e">
									{{ saleList[currentIndex] }}
								</span>

								<!-- 下一条 -->
								<span style="height: 20vh; font-weight: bold; display: block; font-size: 15vh; color: #82545e">
									{{ saleList[(currentIndex + 1) % saleList.length] }}
								</span>
							</div>
							<span style="font-size: 4rem; font-weight: bold; white-space: nowrap">元/克</span>
						</div>
						<!-- <div>
							<span style="font-weight: bold; font-size: 15vh; color: #a7151d" v-if="data.hqConter.length">{{ data.hqConter.find(item => item.productCode == "Au99.99").salePrice || 0 }}</span>
							<span style="font-size: 4rem; font-weight: bold">元/克</span>
						</div> -->
						<div style="display: flex; justify-content: center; align-items: center">
							<span style="border-top: 0.1rem solid #333; height: 0.1rem; width: 10%; position: relative">
								<i style="border-radius: 50%; background: #333; width: 0.5rem; height: 0.5rem; display: block; position: absolute; right: 0.2rem; top: -0.3rem"></i>
							</span>
							<span style="font-size: 10vh">{{ nameList[currentIndex] }}</span>
							<span style="border-top: 0.1rem solid #333; height: 0.1rem; width: 10%; position: relative">
								<i style="border-radius: 50%; background: #333; width: 0.5rem; height: 0.5rem; display: block; position: absolute; left: 0.2rem; top: -0.3rem"></i>
							</span>
						</div>
					</div>
					<i style="border-right: 0.1rem solid #555; height: 20vh"></i>
					<div style="width: 50%; position: relative; top: 5rem">
						<div style="overflow: hidden; display: flex; justify-content: center; align-items: baseline">
							<div style="height: 20vh" :style="{ transform: `translateY(${offset}px)`, transition: transition }">
								<!-- 当前 -->
								<span style="height: 20vh; font-weight: bold; display: block; font-size: 15vh; color: #82545e">
									{{ saleList[currentIndex+1] }}
								</span>

								<!-- 下一条 -->
								<span style="height: 20vh; font-weight: bold; display: block; font-size: 15vh; color: #82545e">
									{{ saleList[(currentIndex + 2) % saleList.length] }}
								</span>
							</div>
							<span style="font-size: 4rem; font-weight: bold; white-space: nowrap">元/克</span>
						</div>
						<!-- <div>
							<span style="font-weight: bold; font-size: 15vh; color: #a7151d" v-if="data.hqConter.length">{{ data.hqConter.find(item => item.productCode == "Au99.99").backPrice }}</span>
							<span style="font-size: 4rem; font-weight: bold">元/克</span>
						</div> -->
						<div style="display: flex; justify-content: center; align-items: center">
							<span style="border-top: 0.1rem solid #333; height: 0.1rem; width: 10%; position: relative">
								<i style="border-radius: 50%; background: #333; width: 0.5rem; height: 0.5rem; display: block; position: absolute; right: 0.2rem; top: -0.3rem"></i>
							</span>
							<span style="font-size: 10vh">{{ nameList[currentIndex+1] }}</span>
							<span style="border-top: 0.1rem solid #333; height: 0.1rem; width: 10%; position: relative">
								<i style="border-radius: 50%; background: #333; width: 0.5rem; height: 0.5rem; display: block; position: absolute; left: 0.2rem; top: -0.3rem"></i>
							</span>
						</div>
					</div>
				</div>
				<!-- 底下棱形 -->
				<div style="display: flex; justify-content: space-between; align-items: center">
					<span style="border-top: 0.1rem solid #555; height: 0.1rem; width: 100%"></span>
					<div style="width: 15vh; height: 15vh; flex-shrink: 0; line-height: 15vh; transform: rotate(45deg); background: #825560; margin: 10vh; color: #fff">
						<span style="transform: rotate(-45deg); display: inline-block; font-size: 4vh; font-weight: bold" v-if="data.hqConter.length">鑫佑福</span>
					</div>
					<span style="border-top: 0.1rem solid #555; height: 0.1rem; width: 100%"></span>
				</div>
				<div style="margin-top:-30px;color:#cd0000">{{ data.basics.company }}</div>

				<!-- <img style="height: 20vh; width: 20vh; position: absolute; left: 50%; border-radius: 50%; background: #333; transform: translate(-50%); top: -10vh" :src="data.basics.logoUrl" /> -->
			</div>
			<div style="padding-top: 1vh; font-size: 6vh">{{ data.time }}</div>
		</div>
	</div>
</template>

<script setup>
// import screenfull from 'screenfull' getCurrentInstance;
import { ref, onMounted, onUnmounted, getCurrentInstance } from "vue";
import api from "@/api/http";
import WaterMarks from "@/components/WaterMarks.vue";
import FloatingWindow from "@/components/FloatingWindow.vue";
import notPage from "@/components/notPage.vue";
import useTimeDifference from "@/composables/useTimeDifference.js";
const offset = ref(0);
const transition = ref("transform 0.6s ease");

const currentIndex = ref(0);

// 你两个金价（自己替换）
const saleList = ref([0, 0]);
const backList = ref([0, 0]);
const nameList = ref([0, 0]);

// const height = window.innerHeight * 0.2;

// const { proxy } = getCurrentInstance()
const { proxy } = getCurrentInstance();
const { calculateTimeDifference, timeDifference, difference2 } = useTimeDifference(); //判断本地时间和服务器时间
const data = ref({
	isMobile: false,
	color: "#000000",
	time: "",
	notPages: false,
	count: 0,
	tabbarHover: 0,
	tabbar: [{ name: "行情" }, { name: "基差" }, { name: "资讯" }, { name: "财经" }],
	hqHeader: ["商 品", "回 购", "销 售", "高 / 低"],
	hqConter: [],
	jxConter: [],
	tenantId: "",
	basics: {}
});
let timerId;
let timerId2;
let timerId3;
let socket = null;
const formatDate = date => {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	const hours = String(date.getHours()).padStart(2, "0");
	const minutes = String(date.getMinutes()).padStart(2, "0");
	const seconds = String(date.getSeconds()).padStart(2, "0");

	return `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;
};
// 定义增加计数的函数
const updateTime = () => {
	// 获取当前时间
	data.value.time = formatDate(new Date());
	//行情
};
const initWebSocket = () => {
	if (difference2.value == "过期") {
		if (socket) socket.close();
		return;
	}

	// websocket 链接
	socket = new WebSocket(proxy.$globalConfig.wsURL);

	// 监听连接打开
	socket.addEventListener("open", () => {
		console.log("WebSocket 连接成功");
		// 发送请求
		const requestData = { msgType: "url", data: data.value.tenantId };
		socket.send(JSON.stringify(requestData));
	});

	// 监听消息
	socket.addEventListener("message", event => {
		let contrastData = data.value.hqConter;
		const response = JSON.parse(event.data);
		if (new Date(data.value.basics.usageTime[0]).getTime() > new Date().getTime()) {
			data.value.hqConter = [];
			data.value.jxConter = [];
			if (socket) socket.close();
			clearInterval(timerId2);
			clearInterval(timerId3);
			return;
		}
		if (response.length >= 1 && response[0].productName) {
			data.value.hqConter = response; // 处理响应数据
			saleList.value = [data.value.hqConter[0].remark||data.value.hqConter[0].salePrice || 0, data.value.hqConter[1].remark||data.value.hqConter[1].salePrice || 0];
			backList.value = [data.value.hqConter[0].backPrice || 0, data.value.hqConter[1].backPrice || 0];
			nameList.value = [data.value.hqConter[0].productName || 0, data.value.hqConter[1].productName || 0];
			calculateTimeDifference(new Date(data.value.basics.usageTime[1]).getTime(), Number(response[0].currentTime));
			if (contrastData.length && data.value.basics.isSwitch) {
				data.value.hqConter.forEach((item, index) => {
					// 清除已有的定时器
					if (item.backTimer) {
						clearTimeout(item.backTimer);
					}
					if (item.saleTimer) {
						clearTimeout(item.saleTimer);
					}
					if (item.backPrice > contrastData[index].backPrice) {
						//判断涨//并且比上一次高
						item.backColor = "red";
						item.backTimer = setTimeout(() => {
							item.backColor = "";
						}, 1000);
					}
					if (item.backPrice < contrastData[index].backPrice) {
						//判断涨//并且比上一次高
						item.backColor = "green";
						item.backTimer = setTimeout(() => {
							item.backColor = "";
						}, 1000);
					}
					//判断销售数据
					if (item.salePrice > contrastData[index].salePrice) {
						//判断涨//并且比上一次高
						item.saleColor = "red";
						item.saleTimer = setTimeout(() => {
							item.saleColor = "";
						}, 1000);
					}
					if (item.salePrice < contrastData[index].salePrice) {
						//判断涨//并且比上一次高
						item.saleColor = "green";
						item.saleTimer = setTimeout(() => {
							item.saleColor = "";
						}, 1000);
					}
				});
			}
		}
	});

	// 监听错误
	socket.addEventListener("error", error => {
		console.error("WebSocket 连接错误:", error);
	});

	// 监听连接关闭
	socket.addEventListener("close", () => {
		console.log("WebSocket 连接关闭，开始重连");
		data.value.hqConter = [];
		// 重连逻辑，这里简单起见直接调用初始化，实际可能需要防抖或重试次数限制
		setTimeout(() => {
			if (difference2.value !== "过期") initWebSocket();
		}, 3000);
	});
};

const updateTime3 = () => {
	//基础数据
	api.get("/metalMarket/sysTenantBoardConf/getByWebUrl/" + data.value.tenantId).then(response => {
		if (response.data) {
			// 基础数据加载成功后，如果还没有建立连接，则初始化 WebSocket
			if (!socket || socket.readyState !== WebSocket.OPEN) {
				initWebSocket();
			}

			// if (data.value.basics) {
			// 	if (data.value.basics.scaleFactor != response.data.scaleFactor) {
			// 		document.body.style.zoom = response.data.scaleFactor;
			// 	}
			// } else {
			// 	document.body.style.zoom = response.data.scaleFactor;
			// }
			data.value.basics = response.data; // 处理响应数据

			if (data.value.basics.expireFlag || !data.value.basics.status) {
				difference2.value = "过期";
				if (socket) socket.close();
				clearInterval(timerId2);
				clearInterval(timerId3);
			}
		} else {
			clearInterval(timerId3);
		}
	});
};
function loadWeixinScript() {
	//加载微信sdk
	return new Promise((resolve, reject) => {
		const script = document.createElement("script");
		script.src = "https://res.wx.qq.com/open/js/jweixin-1.4.0.js";
		script.onload = () => resolve();
		script.onerror = () => reject(new Error("Weixin script load error"));
		document.head.appendChild(script);
	});
}
const initializeWeixinSDK = config => {
	const wx = window.wx; // 确保 wx 是从 window 对象中获取
	const wxConfig = {
		debug: false,
		appId: config.appId,
		timestamp: config.timestamp,
		nonceStr: config.nonceStr,
		signature: config.signature,
		jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"]
	};
	wx.config(wxConfig);
	wx.ready(() => {
		const timestamp = new Date().getTime(); // 获取当前时间戳
		const imageUrlWithTimestamp = `${data.value.basics.shareLogoUrl}?t=${timestamp}`;
		// 微信SDK初始化成功后的回调
		wx.onMenuShareTimeline({
			//朋友圈
			title: data.value.basics.logoDesc,
			link: window.location.href,
			imgUrl: imageUrlWithTimestamp,
			success: function () {
				// 用户确认分享后执行的回调函数
			},
			cancel: function () {
				// 用户取消分享后执行的回调函数
			}
		});

		wx.onMenuShareAppMessage({
			//pengyop
			title: data.value.basics.logoDesc,
			desc: data.value.basics.shareDesc,
			link: window.location.href,
			imgUrl: imageUrlWithTimestamp,
			success: function () {
				console.log();
				// 用户确认分享后执行的回调函数
			},
			cancel: function (err) {
				// 用户取消分享后执行的回调函数
			}
		});
	});

	wx.error(function (res) {
		console.error("Weixin config error:", res);
	});
};
async function getWeixinConfig(url) {
	try {
		const response = await api.get("/metalMarket/sysTenantBoardConf/getWxJsConfig?url=" + url);
		return response.data;
	} catch (error) {
		console.error("Error fetching Weixin config:", error);
		throw error;
	}
}

onMounted(async () => {
	// setInterval(() => {
	// 	// 1. 开始滚动：向下移动一个高度
	// 	offset.value = -height;
	// 	setTimeout(() => {
	// 		// 2. 关闭过渡效果，准备瞬间归位
	// 		transition.value = "none";
	// 		// 3. 瞬间归位到初始位置 (视觉上还是旧数据，因为还没切索引)
	// 		offset.value = 0;
	// 		// 4. 等待浏览器完成“归位”的渲染
	// 		requestAnimationFrame(() => {
	// 			// 5. 再次请求帧，确保在下一帧开始前切换数据
	// 			// 此时用户看到的是归位后的状态，紧接着切换数据
	// 			currentIndex.value = (currentIndex.value + 1) % saleList.value.length;

	// 			// 6. 数据切换后，强制浏览器重绘一帧（此时显示新数据但在顶部位置）
	// 			// 这一步是为了防止直接开动画导致从 0 到 -height 的重复播放或闪烁
	// 			requestAnimationFrame(() => {
	// 				// 7. 重新开启过渡效果，为下一次定时器触发的滚动做准备
	// 				transition.value = "transform 0.6s ease";
	// 			});
	// 		});
	// 	}, 600); // 这里的 600 对应 transition 的时间，确保滚动完成后再归位
	// }, 3000);
	// window.location.href = '/webSocketPage';
	// this.$router.push({ name: 'webSocketPage' });
	await loadWeixinScript();
	// const url = window.location.href.split("#")[0]; // 当前页面的URL
	const url = window.location.href; // 获取当前页面的完整 URL
	const config = await getWeixinConfig(url);
	initializeWeixinSDK(config);

	const urlParams = new URLSearchParams(window.location.search);
	data.value.tenantId = urlParams.get("v");
	updateTime3();
	timerId = setInterval(updateTime, 500);
	timerId3 = setInterval(updateTime3, 120000);

	// //基差
	api.get("/metalMarket/board/listBasis/" + data.value.tenantId).then(response => {
		data.value.jxConter = response.data; // 处理响应数据
	});
});
//基础信息

onUnmounted(() => {
	clearInterval(timerId);
	clearInterval(timerId2);
	if (socket) {
		socket.close();
		socket = null;
	}
});
</script>
<script>
export default {
	name: "homeDP"
};
</script>
<style scoped>
.red {
	background: red;
	color: #fff !important;
}
.green {
	background: green;
	color: #fff !important;
}

html {
	background: rgb(42, 52, 58);
}
.gd {
	font-size: 20px;
	line-height: 24px !important;
	padding-top: 14px;
	font-weight: bold;
}
.phone_icon {
	display: none;
}
.dp {
	position: relative;
	overflow: hidden;
	/* background: #000000; */
	color: #fff;
	width: 100%;
	height: 100vh;
}

.dp-conter {
	padding-bottom: 40px;
	padding-top: 100px;
}

.dp-hq-header,
.dp-hq-item {
	display: flex;
	align-items: center;
	justify-content: space-around;
	text-align: center;

	height: 70px;
	font-weight: bold;
	font-size: 24px;
}

.dp-hq-item {
	white-space: nowrap;
	font-size: 28px;
	/* height: 70px; */
}

.dp-hq-item > div {
	width: 100%;
	height: 70px;
	line-height: 70px;
}

.dp-hq-pmd {
	font-size: 16px;
	height: 10px;
	padding-right: 20px;
	background: #191c21;
	scrollbar-width: none;
}

.dp-hq-time {
	position: absolute;
	right: 10px;
	top: 45px;
	text-align: right;
	color: red;
	font-size: 24px;
}

.dp-hq-conter {
	/* border-top: 1px solid #fff; */
	/* background: red; */
	overflow-y: scroll;
	height: calc(100vh - 250px);
	scrollbar-width: none;
	position: relative;
	/* Firefox */
}

.dp-hq-pmd > div::-webkit-scrollbar,
.dp-hq-conter::-webkit-scrollbar {
	display: none;
	/* Safari 和 Chrome */
}

.dp-cj,
.dp-jc,
.dp-zx {
	height: calc(100vh - 160px);
}

.dp-title {
	position: fixed;
	display: flex;
	justify-content: space-between;
	top: 0;
	width: 100%;
	background: #000000;
	height: 100px;
	line-height: 80px;
	z-index: 1;
}
.dp-title-item {
	line-height: 70px;
	font-weight: bold;
	font-size: 50px;
}
.dp-title-item > div {
	margin: 0 5px;
}
.dp-title-item2 {
	line-height: 20px;
	font-size: 30px;
	margin-top: 20px;
}
.dp-title-item,
.dp-title-item2 {
	text-align: center;
}
.dp-tabbar {
	display: flex;
	align-items: center;
	justify-content: space-around;
	text-align: center;
	position: fixed;
	bottom: 0;
	width: 100%;
	background: #191c21;
	font-size: 18px;
	border-top: 1px solid #fff;
}

.dp-item {
	cursor: pointer;
	width: 100%;
	height: 60px;
	line-height: 60px;
	font-weight: bold;
}
.msg > div {
	font-size: 14px;
	margin-top: 10px;
	padding-left: 10px;
}
.dqtx {
	width: 100vw;
	height: 100vh;
	background: #fff;
	position: fixed;
	z-index: 99999999;
	color: red;
	text-align: center;
	padding: 20px 0;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 30px;
}
.dqtx p {
	margin-top: 20px;
}
/* .tabbar-hover {
	background: #000000;
} */
@media only screen and (max-width: 767px) {
	.dqtx {
		font-size: 18px;
	}
	.dp-hq-pmd {
		height: 30px;
		padding: 10px 0;
	}
	body {
		zoom: 1 !important;
	}
	.gd {
		font-size: 16px;
		line-height: 20px !important;
		margin-top: 0;
	}
	.phone_icon {
		display: block;
		float: right;
		padding: 8px;
		width: 50px;
	}
	.phone_icon img {
		width: 100%;
		height: auto;
	}
	.dp-hq-item {
		font-weight: bold;
		font-size: 20px;
		height: auto;
		border-bottom: 1px solid #292a2c;
	}
	.dp-hq-item > div {
		height: 55px;
		line-height: 55px;
		border-right: 1px solid #333538;
	}
	.dp-hq-item > div:last-child {
		padding-top: 10px;
		border-right: none;
	}

	.dp-tabbar {
		background: #fff;
	}
	.dp-item {
		font-size: 16px;
		font-weight: 400;
	}
	/* .tabbar-hover {
		background: #f5f5f5;
	} */
	.dp-hq-header {
		font-weight: bold;
		font-size: 20px;
		height: 50px;
	}
	.dp-hq-time {
		top: 50px;
		font-size: 16px;
	}
	.dp-conter {
		padding-top: 70px;
	}
	.dp-hq-conter {
		height: calc(100vh - 220px);
	}
	.dp-title {
		height: 70px;
	}
	.dp-title-item {
		font-size: 35px;
		line-height: 50px;
	}
	.dp-title-item2 {
		font-size: 20px;
		line-height: 10px;
	}
	.dp-title-item > div {
		margin: 0px;
	}
	.marqueee {
		margin-top: 14px;
	}
}
</style>
